import { Box, Flex, HStack, Icon, Text } from '@chakra-ui/react';

import Content from '~/containers/Content';

import { IoRemoveOutline, IoAddOutline } from 'react-icons/io5';

import * as fp from 'lodash/fp';

import formatPriceNumber from '~/utils/formatPriceNumber';

type ItemControlBarProps = {
  count: number;
  total: number;
  maxCount: number;
  isDisabled?: boolean;
  onChangeCount: (count: number | ((prev: number) => number)) => void;
  onConform?: () => void;
};

export default function ItemControlBar({
  count,
  total,
  maxCount,
  isDisabled = false,
  onChangeCount,
  onConform,
}: ItemControlBarProps) {
  const handleIncrement = () => {
    onChangeCount((prev) => (fp.gt(prev + 1, maxCount) ? prev : prev + 1));
  };

  const handleDecrement = () => {
    onChangeCount((prev) => Math.max(prev - 1, 1));
  };

  return (
    <Content bgColor={isDisabled ? '#877861' : 'secondary'} px={4}>
      <Flex align="stretch">
        <Box flex="1" py={6}>
          <HStack>
            <Icon
              as={IoRemoveOutline}
              cursor="pointer"
              boxSize="1.5rem"
              color="white"
              onClick={handleDecrement}
            />
            <Text color="white" w="3rem" textAlign="center" fontWeight="bold">
              {count}
            </Text>
            <Icon
              as={IoAddOutline}
              cursor="pointer"
              boxSize="1.5rem"
              color="white"
              onClick={handleIncrement}
            />
          </HStack>
        </Box>

        <Flex
          cursor="pointer"
          flex="2"
          align="center"
          py={4}
          onClick={isDisabled ? undefined : onConform}
        >
          <Text color="white" fontWeight="bold" flex="1" textAlign="center">
            加入訂單
          </Text>

          <Text color="white" flex="1" textAlign="end" fontSize="sm">
            {formatPriceNumber(total)}
          </Text>
        </Flex>
      </Flex>
    </Content>
  );
}
